/**
 * Created by gaoying on 2017/9/21.
 */

// export const name = state => state.data.name;
const getters = {
  cur_org: (state) => state.org.org,
  lead: (state) => state.org.lead,
  pc_tabs: (state) => state.org.pc_tabs,
  can_manage_staff: (state) => state.org.can_manage_staff,
  staff: (state) => state.org.staff,
  staff_count: (state) => state.org.staff_count,
  cur_orgProfile: (state) => state.user.orgProfile,
  teacher_assistant: (state) => state.org && state.org.org ? !!state.org.org.teacher_assistant : false,
  inner_height: (state) => state.other.inner_height,
  is_pad: (state) => state.other.is_pad,
  cache_datas: (state) => state.storeCache.cache_data_list,
  lock_errors: (state) => state.other.repeat_error_locks,
  user_set_api: (state) => state.other.user_set_api,
  current_cookie_optinons: (state) => state.other.cookieOptions,

  // 是否是总校管理机构
  is_total_manange_org: (state) => {
    const org_type_head_list = [
      'headquarters',
      'region'
    ]

    const cur_org = state.org.org

    const {
      type: org_type
    } = cur_org || {}

    return org_type_head_list.includes(org_type)
  }
}

export default getters
